import React, { useState, useMemo } from 'react';
import CreditRefundedModal from './CreditRefundedModal';
import CreditRefundedDropdown from './CreditRefundedDropdown';
import { formatAmount } from '../../../utils/formatAmount';
import { useStatsCard } from '../../../hooks/Refund/useStatsCard';

function StatsCard({
    totalCreditRefunded,
    modalTitle = "Total Credits Refunded",
    columnTitle = "No. of Credits Issued",
    cardImg = "/assets/incentive-purchased.svg",
    totalAmount,
    user = false
}) {
    const { show, handleShow, handleClose, formattedTotal, projects } = useStatsCard({ totalCreditRefunded, user });


    return (
        <>
            <div className="single-card">
                <div className="twice-set-items">
                    <img
                        src={cardImg}
                        alt="img"
                        className="img-fluid"
                    />
                    <div className="inner-text">
                        <p>{modalTitle}</p>
                        <h6>
                            {modalTitle === "Total Credits Refunded" && ("$")}{totalAmount ? totalAmount :formattedTotal}
                            {/* <span className="green-text">+0.8%</span> */}
                        </h6>
                    </div>
                </div>
                <div className="bottom-text">
                    {projects.length > 0 && (
                        <>
                            {/* Show first item if available */}
                            {projects.length >= 1 && (
                                <p className="uni-text">
                                    <span></span>
                                    {user ? formatAmount(projects[0].amount, user) : formatAmount(projects[0].amount, user)} {projects[0].id}
                                </p>
                            )}

                            {/* Show second item if available */}
                            {projects.length >= 2 && (
                                <p className="uni-text">
                                    <span></span>
                                    {user ? formatAmount(projects[1].amount, user) : formatAmount(projects[1].amount, user)} {projects[1].id}
                                </p>
                            )}
                        </>
                    )}
                </div>

                {totalCreditRefunded?.length > 2 &&<CreditRefundedDropdown
                    totalCreditRefunded={totalCreditRefunded?.slice(2)}
                    handleViewAll={handleShow}
                    user={user}
                />}
            </div>

            <CreditRefundedModal
                show={show}
                handleClose={handleClose}
                totalCreditRefunded={totalCreditRefunded}
                modalTitle={modalTitle}
                columnTitle={columnTitle}
                user={user}
            />
        </>
    );
}

export default StatsCard;
//v2
// import React, { useState, useMemo } from 'react';
// import { Dropdown } from 'react-bootstrap';
// import CreditRefundedModal from './CreditRefundedModal';
// import CreditRefundedDropdown from './CreditRefundedDropdown';
// import { formatAmount } from '../../../utils/formatAmount';

// function CreditRefunded({
//     totalCreditRefunded,
//     modalTitle = "Total Credits Refunded",
//     columnTitle = "No. of Credits Issued",
//     cardImg = "/assets/incentive-purchased.svg",
//     user = false
// }) {
//     const [show, setShow] = useState(false);

//     // Get the right property to calculate based on data structure
//     const getValueProperty = (item) => {
//         if (item.creditRefunded !== undefined) return 'creditRefunded';
//         if (item.totalUsersRefunded !== undefined) return 'totalUsersRefunded';
//         if (item.creditConsumed !== undefined) return 'creditConsumed';
//         if (item.tokenPurchased !== undefined) return 'tokenPurchased';
//         return null;
//     };

//     // Calculate total amount across all items
//     const totalAmount = useMemo(() => {
//         if (!totalCreditRefunded || totalCreditRefunded.length === 0) return 0;

//         return totalCreditRefunded.reduce((acc, curr) => {
//             const property = getValueProperty(curr);
//             return acc + (property ? curr[property] || 0 : 0);
//         }, 0);
//     }, [totalCreditRefunded]);

//     // Format the total amount
//     const formattedTotal = useMemo(() => {
//         if (user) {
//             // For user counts, don't use dollar sign and just show the number
//             return totalAmount.toLocaleString();
//         }

//         // For monetary values
//         if (totalAmount >= 1000000) {
//             return `${(totalAmount / 1000000).toFixed(2)}M`;
//         } else if (totalAmount >= 1000) {
//             return `${(totalAmount / 1000).toFixed(0)}K`;
//         }
//         return `${totalAmount.toFixed(2)}`;
//     }, [totalAmount, user]);

//     // Get first two projects for bottom text
//     const firstTwoProjects = useMemo(() => {
//         if (!totalCreditRefunded || totalCreditRefunded.length === 0) {
//             return [];
//         }

//         // Map the data with appropriate property
//         const mappedData = totalCreditRefunded.map(item => {
//             const property = getValueProperty(item);
//             return {
//                 id: item._id,
//                 amount: property ? item[property] : 0
//             };
//         });

//         // Return first two or duplicate the first one if only one exists
//         if (mappedData.length === 1) {
//             return [mappedData[0], mappedData[0]];
//         }

//         return mappedData.slice(0, 2);
//     }, [totalCreditRefunded]);

    
//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     return (
//         <>
//             <div className="single-card">
//                 <div className="twice-set-items">
//                     <img
//                         src={cardImg}
//                         alt="img"
//                         className="img-fluid"
//                     />
//                     <div className="inner-text">
//                         <p>{modalTitle}</p>
//                         <h6>
//                             {formattedTotal}
//                             {/* <span className="green-text">+0.8%</span> */}
//                         </h6>
//                     </div>
//                 </div>
//                 <div className="bottom-text">
//                     {firstTwoProjects.length > 0 && (
//                         <>
//                             <p className="uni-text">
//                                 <span></span>
//                                 {user ? firstTwoProjects[0].amount : formatAmount(firstTwoProjects[0].amount, user)} {firstTwoProjects[0].id}
//                             </p>
//                             <p className="uni-text">
//                                 <span></span>
//                                 {user ? firstTwoProjects[1].amount : formatAmount(firstTwoProjects[1].amount, user)} {firstTwoProjects[1].id}
//                             </p>
//                         </>
//                     )}
//                 </div>

//                 <CreditRefundedDropdown
//                     totalCreditRefunded={totalCreditRefunded}
//                     handleViewAll={handleShow}
//                     user={user}
//                 />
//             </div>

//             <CreditRefundedModal
//                 show={show}
//                 handleClose={handleClose}
//                 totalCreditRefunded={totalCreditRefunded}
//                 modalTitle={modalTitle}
//                 columnTitle={columnTitle}
//                 user={user}
//             />
//         </>
//     );
// }

// export default CreditRefunded;

// import React, { useState, useMemo } from 'react';
// import { Dropdown } from 'react-bootstrap';
// import CreditRefundedModal from './CreditRefundedModal';
// import CreditRefundedDropdown from './CreditRefundedDropdown';

// function CreditRefunded({ cardImg, totalCreditRefunded, modalTitle, columnTitle, user }) {
//     const [show, setShow] = useState(false);
//     console.log(user, 'useruseruser');

//     // Calculate total credit refunded
//     const totalAmount = useMemo(() => {
//         if (!totalCreditRefunded || totalCreditRefunded.length === 0) return 0;

//         return totalCreditRefunded.reduce((acc, curr) => {
//             return acc + (curr.creditRefunded || 0);
//         }, 0);
//     }, [totalCreditRefunded]);

//     // Format the total amount
//     const formattedTotal = useMemo(() => {
//         if (totalAmount >= 1000000) {
//             return user ? `${totalAmount}M` :  `$${(totalAmount / 1000000).toFixed(2)}M`;
//         } else if (totalAmount >= 1000) {
//             return user ? `${totalAmount}M` : `$${(totalAmount / 1000).toFixed(0)}K`;
//         }
//         return user ? `${totalAmount}` : `$${totalAmount.toFixed(2)}`;
//     }, [totalAmount]);

//     // Get first two projects for bottom text
//     const firstTwoProjects = useMemo(() => {
//         if (!totalCreditRefunded || totalCreditRefunded.length === 0) {
//             return [];
//         }

//         // Return first two or duplicate the first one if only one exists
//         if (totalCreditRefunded.length === 1) {
//             const item = totalCreditRefunded[0];
//             return [
//                 { id: item._id, amount: item.creditRefunded },
//                 { id: item._id, amount: item.creditRefunded }
//             ];
//         }

//         return totalCreditRefunded.slice(0, 2).map(item => ({
//             id: item._id,
//             amount: item.creditRefunded
//         }));
//     }, [totalCreditRefunded]);

//     // Format the amount for display in bottom text
//     // const formatAmount = (amount) => {
//     //     if (amount >= 1000000) {
//     //         return `$${(amount / 1000000).toFixed(1)}m`;
//     //     }
//     //     return `$${(amount / 1000).toFixed(0)}K`;
//     // };
//     const formatAmount = (amount) => {
//         if (!amount && amount !== 0) return '$0';

//         if (amount >= 1000000) {
//             return `$${(amount)}`;
//         }
//         return `$${amount}`;
//     };
//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     return (
//         <>
//             <div className="single-card">
//                 <div className="twice-set-items">
//                     <img
//                         src={cardImg}
//                         alt="img"
//                         className="img-fluid"
//                     />
//                     <div className="inner-text">
//                         <p>{modalTitle}</p>
//                         <h6>
//                             {formattedTotal}
//                             {/* <span className="green-text">+0.8%</span> */}
//                         </h6>
//                     </div>
//                 </div>
//                 <div className="bottom-text">
//                     {firstTwoProjects.length > 0 && (
//                         <>
//                             <p className="uni-text">
//                                 <span></span>
//                                 {formatAmount(firstTwoProjects[0].amount)} {firstTwoProjects[0].id}
//                             </p>
//                             <p className="uni-text">
//                                 <span></span>
//                                 {formatAmount(firstTwoProjects[1].amount)} {firstTwoProjects[1].id}
//                             </p>
//                         </>
//                     )}
//                 </div>

//                 <CreditRefundedDropdown
//                     totalCreditRefunded={totalCreditRefunded}
//                     handleViewAll={handleShow}
//                 />
//             </div>

//             <CreditRefundedModal
//                 show={show}
//                 handleClose={handleClose}
//                 totalCreditRefunded={totalCreditRefunded}
//                 modalTitle={modalTitle}
//                 columnTitle={columnTitle}
//             />
//         </>
//     );
// }

// export default CreditRefunded;